<template>
  <div class="am-acord-email-history-modal">
    <a href="javascript:void(0)" @click="acordEmailPopup" title="View Email History">
      <div class="am-acord-email-history-button">
        <input type="button" value="Email History" class="acordLibraryButton acordLibraryEmailButton">
      </div>
    </a>
    <modal name="acordEmailHistory" classes="am-vue-modal" :clickToClose="false" :pivotY="0.5" width="1000px" height="600px">
      <div class="am-acord-email-title-bar am-main-top-box">
        <span class="am-acord-email-title am-main-top-box-title"><strong>Acord Email History</strong></span>
      </div>
      <div class="am-acord-email-history">
        <table class="am-acord-email-history-table results resultsTable">
          <thead>
          <tr>
            <th>Form</th>
            <th>Description</th>
            <th>From Address</th>
            <th>To Address</th>
            <th>CC</th>
            <th>BCC</th>
            <th>Subject</th>
            <th>Date Sent</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="email in acordEmailHistoryModal" :key="email.id">
            <td>{{email.form}}</td>
            <td>{{email.name}}</td>
            <td>{{email.fromAddress}}</td>
            <td>{{email.toAddress}}</td>
            <td>{{email.cc}}</td>
            <td>{{email.bcc}}</td>
            <td>{{email.SUBJECT}}</td>
            <td>{{email.sentDate}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="am-acord-email-history-footer">
        <button class="am-acord-email-history-close-button" @click="$modal.hide('acordEmailHistory')">CANCEL</button>
      </div>
    </modal>
  </div>
</template>

<script>
import api from './../http'
export default {
  name: 'EmailHistory',
  asyncComputed: {
    acordEmailHistoryModal () {
      return api.makeRequest('/email/acord-email-history').then(
        (data) => {
          return data.data.results
        }
      )
    }
  },
  methods: {
    acordEmailPopup () {
      this.$modal.show('acordEmailHistory')
    }
  }
}
</script>

<style scoped>

  .am-acord-email-title-bar {
    height: 33px;
    background-color:#428bca;
    background-image:linear-gradient(to bottom, #428bca 0%,#2d6ca2 100%);
    background-repeat:repeat;
  }

  .am-acord-email-title {
    font-size: 14px;
    color: #FDFEFE;
    float: left;
    margin-top: 4px;
    margin-left: 15px;
  }

  .am-acord-email-history{
    padding: 1em 2.2em;
    height: 85%;
    overflow-y: auto;

  }

  .resultsTable{
    width: 100%;
    position: relative;
  }

  .am-acord-email-history-close-button{
    bottom: 0;
    left: 90%;
    position: absolute;
    margin-bottom: 10px;
    background-color: #900;
    background-image: linear-gradient(to bottom, #990000 0%,#8f0007 100%);
    background-repeat: repeat;
    color: #fff;
    border-radius: 3px;
    cursor: pointer;
    font-family: inherit;
    letter-spacing: .1em;
    line-height: 1em;
    padding: .75em 2em;
    border: 0;
  }

  .am-acord-email-history-footer{
    border-top: 1px solid #c5c5c5;
  }

  .am-acord-email-history-modal{
    float:left;
    display:block;
  }
  .v--modal-overlay {
    background-color: rgba(0,0,0,0.7);
  }
</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>

